/* istanbul ignore file */
export const DISCLAIMER =
  'Disclaimer: By acknowledging, you understand that by submitting a backup offer, you do not have a guarantee of acquiring this property'
